/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseOfString } from '../models/api-response-of-string';
import { Practice } from '../models/practice';
import { userPracticesFetchSettings } from '../fn/user-practices/user-practices-fetch-settings';
import { UserPracticesFetchSettings$Params } from '../fn/user-practices/user-practices-fetch-settings';
import { userPracticesGetAllPracticesOfMappedUser } from '../fn/user-practices/user-practices-get-all-practices-of-mapped-user';
import { UserPracticesGetAllPracticesOfMappedUser$Params } from '../fn/user-practices/user-practices-get-all-practices-of-mapped-user';
import { userPracticesGetAllPracticesOfUser } from '../fn/user-practices/user-practices-get-all-practices-of-user';
import { UserPracticesGetAllPracticesOfUser$Params } from '../fn/user-practices/user-practices-get-all-practices-of-user';
import { userPracticesGetAllSourcePracticesOfMappedUser } from '../fn/user-practices/user-practices-get-all-source-practices-of-mapped-user';
import { UserPracticesGetAllSourcePracticesOfMappedUser$Params } from '../fn/user-practices/user-practices-get-all-source-practices-of-mapped-user';
import { userPracticesSetAllPracticesOfMappedUser } from '../fn/user-practices/user-practices-set-all-practices-of-mapped-user';
import { UserPracticesSetAllPracticesOfMappedUser$Params } from '../fn/user-practices/user-practices-set-all-practices-of-mapped-user';

@Injectable({ providedIn: 'root' })
export class UserPracticesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userPracticesGetAllPracticesOfUser()` */
  static readonly UserPracticesGetAllPracticesOfUserPath = '/userpractices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPracticesGetAllPracticesOfUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPracticesGetAllPracticesOfUser$Response(params?: UserPracticesGetAllPracticesOfUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Practice>>> {
    return userPracticesGetAllPracticesOfUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userPracticesGetAllPracticesOfUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPracticesGetAllPracticesOfUser(params?: UserPracticesGetAllPracticesOfUser$Params, context?: HttpContext): Observable<Array<Practice>> {
    return this.userPracticesGetAllPracticesOfUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Practice>>): Array<Practice> => r.body)
    );
  }

  /** Path part for operation `userPracticesFetchSettings()` */
  static readonly UserPracticesFetchSettingsPath = '/userpractices/{practiceId}/settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPracticesFetchSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPracticesFetchSettings$Response(params: UserPracticesFetchSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Practice>>> {
    return userPracticesFetchSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userPracticesFetchSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPracticesFetchSettings(params: UserPracticesFetchSettings$Params, context?: HttpContext): Observable<Array<Practice>> {
    return this.userPracticesFetchSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Practice>>): Array<Practice> => r.body)
    );
  }

  /** Path part for operation `userPracticesGetAllPracticesOfMappedUser()` */
  static readonly UserPracticesGetAllPracticesOfMappedUserPath = '/mappeduserpractices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPracticesGetAllPracticesOfMappedUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPracticesGetAllPracticesOfMappedUser$Response(params?: UserPracticesGetAllPracticesOfMappedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Practice>>> {
    return userPracticesGetAllPracticesOfMappedUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userPracticesGetAllPracticesOfMappedUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPracticesGetAllPracticesOfMappedUser(params?: UserPracticesGetAllPracticesOfMappedUser$Params, context?: HttpContext): Observable<Array<Practice>> {
    return this.userPracticesGetAllPracticesOfMappedUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Practice>>): Array<Practice> => r.body)
    );
  }

  /** Path part for operation `userPracticesGetAllSourcePracticesOfMappedUser()` */
  static readonly UserPracticesGetAllSourcePracticesOfMappedUserPath = '/mappeduserpracticesforsource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPracticesGetAllSourcePracticesOfMappedUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPracticesGetAllSourcePracticesOfMappedUser$Response(params?: UserPracticesGetAllSourcePracticesOfMappedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Practice>>> {
    return userPracticesGetAllSourcePracticesOfMappedUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userPracticesGetAllSourcePracticesOfMappedUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPracticesGetAllSourcePracticesOfMappedUser(params?: UserPracticesGetAllSourcePracticesOfMappedUser$Params, context?: HttpContext): Observable<Array<Practice>> {
    return this.userPracticesGetAllSourcePracticesOfMappedUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Practice>>): Array<Practice> => r.body)
    );
  }

  /** Path part for operation `userPracticesSetAllPracticesOfMappedUser()` */
  static readonly UserPracticesSetAllPracticesOfMappedUserPath = '/setmappeduserpractices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPracticesSetAllPracticesOfMappedUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPracticesSetAllPracticesOfMappedUser$Response(params?: UserPracticesSetAllPracticesOfMappedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
    return userPracticesSetAllPracticesOfMappedUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userPracticesSetAllPracticesOfMappedUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPracticesSetAllPracticesOfMappedUser(params?: UserPracticesSetAllPracticesOfMappedUser$Params, context?: HttpContext): Observable<ApiResponseOfString> {
    return this.userPracticesSetAllPracticesOfMappedUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOfString>): ApiResponseOfString => r.body)
    );
  }

}
